"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _dayjs = _interopRequireDefault(require("dayjs"));

var _Day = _interopRequireDefault(require("./Day"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Week = function Week(_ref) {
  var isFirst = _ref.isFirst,
      week = _ref.week,
      month = _ref.month,
      year = _ref.year,
      fromDate = _ref.fromDate,
      toDate = _ref.toDate,
      hoverDate = _ref.hoverDate,
      onSelectDate = _ref.onSelectDate,
      onHoverDate = _ref.onHoverDate,
      totalDay = _ref.totalDay,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      isSingle = _ref.isSingle,
      weekIndex = _ref.weekIndex,
      highlightToday = _ref.highlightToday;

  function generateDay() {
    return _toConsumableArray(Array(week.days).keys()).map(function (index) {
      var dateIndex = index + week.start;
      var dateValue = (0, _dayjs.default)("".concat(year, "-").concat(month + 1, "-").concat(dateIndex));
      var disabled = minDate && dateValue.isBefore(minDate, 'date') || maxDate && dateValue.isAfter(maxDate, 'date');
      var selected = dateValue.isSame(fromDate, 'date') || dateValue.isSame(toDate, 'date');
      var hovered = false;
      var highlight = highlightToday && dateValue.isSame(new Date(), 'date');

      if (fromDate && !fromDate.isSame(toDate, 'date') && !isSingle) {
        if (toDate && !fromDate.isAfter(dateValue, 'date') && !toDate.isBefore(dateValue, 'date')) {
          hovered = true;
        }

        if (!toDate && !dateValue.isBefore(fromDate, 'date') && !(hoverDate && hoverDate.isBefore(dateValue, 'date')) && fromDate.isBefore(hoverDate, 'date')) {
          hovered = true;
        }
      }

      var isEndDate = false;

      if (dateValue.isSame(toDate, 'date') || !toDate && dateValue.isSame(hoverDate, 'date')) {
        isEndDate = true;
      }

      return /*#__PURE__*/_react.default.createElement(_Day.default, {
        key: index,
        dateIndex: dateIndex,
        dateValue: dateValue,
        hoverDate: hoverDate,
        onSelectDate: onSelectDate,
        onHoverDate: onHoverDate,
        selected: selected,
        hovered: hovered,
        highlight: highlight,
        disabled: disabled,
        isEndDay: isEndDate,
        totalDay: totalDay,
        weekDayIndex: index,
        weekIndex: weekIndex
      });
    });
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)('week', {
      first: isFirst
    })
  }, generateDay());
};

Week.propTypes = {
  isFirst: _propTypes.default.bool,
  week: _propTypes.default.object,
  month: _propTypes.default.number,
  year: _propTypes.default.number,
  fromDate: _propTypes.default.instanceOf(Date),
  toDate: _propTypes.default.instanceOf(Date),
  hoverDate: _propTypes.default.instanceOf(Date),
  totalDay: _propTypes.default.number,
  onSelectDate: _propTypes.default.func,
  onHoverDate: _propTypes.default.func,
  minDate: _propTypes.default.instanceOf(Date),
  maxDate: _propTypes.default.instanceOf(Date),
  isSingle: _propTypes.default.bool,
  weekIndex: _propTypes.default.number,
  highlightToday: _propTypes.default.bool
};
Week.defaultProps = {
  isFirst: false,
  week: {},
  month: null,
  year: null,
  fromDate: null,
  toDate: null,
  totalDay: null,
  hoverDate: null,
  onSelectDate: function onSelectDate() {},
  onHoverDate: function onHoverDate() {},
  minDate: null,
  maxDate: null,
  isSingle: false,
  weekIndex: 0,
  highlightToday: false
};
var _default = Week;
exports.default = _default;